import { render, staticRenderFns } from "./AreaRealProduction.vue?vue&type=template&id=4f6d18c2&scoped=true&"
import script from "./AreaRealProduction.vue?vue&type=script&lang=js&"
export * from "./AreaRealProduction.vue?vue&type=script&lang=js&"
import style0 from "./AreaRealProduction.vue?vue&type=style&index=0&id=4f6d18c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6d18c2",
  null
  
)

export default component.exports